require('../../../modules/es6.string.starts-with');
module.exports = require('../../../modules/_entry-virtual')('String').startsWith;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/virtual/starts-with.js
// module id = 1442
// module chunks = 1